
$(document).ready(function () {
  if (window.matchMedia('(min-width: 750px)').matches) {
    $('.custom-collection-list-slider').slick({
      slidesToShow: 4.1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: `<svg class="slick-arrow slick-prev" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M14.558 24.558a.625.625 0 0 0 0 .884l3.977 3.977a.625.625 0 1 0 .884-.884L15.884 25l3.535-3.535a.625.625 0 1 0-.884-.884zM35 25.625a.625.625 0 1 0 0-1.25zM15 25v.625h20v-1.25H15z" fill="#294982"/></svg>`,
      nextArrow: `<svg class="slick-arrow slick-next" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M35.442 24.558a.625.625 0 0 1 0 .884l-3.977 3.977a.625.625 0 1 1-.884-.884L34.116 25l-3.535-3.535a.625.625 0 1 1 .884-.884zM15 25.625a.625.625 0 1 1 0-1.25zM35 25v.625H15v-1.25h20z" fill="#294982"/></svg>`,
      responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
            }
          },
           {
            breakpoint: 749,
            settings: {
              slidesToShow: 2.1,
            }
          },
             {
            breakpoint: 575,
            settings: {
              slidesToShow: 2.1,
            }
          },
        ]
    });
  }

  $('.custom-featured-slider').slick({
      slidesToShow: 4.1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: `<svg class="slick-arrow slick-prev" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M14.558 24.558a.625.625 0 0 0 0 .884l3.977 3.977a.625.625 0 1 0 .884-.884L15.884 25l3.535-3.535a.625.625 0 1 0-.884-.884zM35 25.625a.625.625 0 1 0 0-1.25zM15 25v.625h20v-1.25H15z" fill="#294982"/></svg>`,
      nextArrow: `<svg class="slick-arrow slick-next" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M35.442 24.558a.625.625 0 0 1 0 .884l-3.977 3.977a.625.625 0 1 1-.884-.884L34.116 25l-3.535-3.535a.625.625 0 1 1 .884-.884zM15 25.625a.625.625 0 1 1 0-1.25zM35 25v.625H15v-1.25h20z" fill="#294982"/></svg>`,
      responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
            }
          },
           {
            breakpoint: 749,
            settings: {
              slidesToShow: 2.1,
            }
          },
             {
            breakpoint: 575,
            settings: {
              slidesToShow: 2.1,
            }
          },
        ]
    });
 $('.review_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      prevArrow: `<svg class="slick-arrow slick-prev" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M14.558 24.558a.625.625 0 0 0 0 .884l3.977 3.977a.625.625 0 1 0 .884-.884L15.884 25l3.535-3.535a.625.625 0 1 0-.884-.884zM35 25.625a.625.625 0 1 0 0-1.25zM15 25v.625h20v-1.25H15z" fill="#294982"/></svg>`,
      nextArrow: `<svg class="slick-arrow slick-next" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24.375" stroke="#294982" stroke-width="1.25"/><path d="M35.442 24.558a.625.625 0 0 1 0 .884l-3.977 3.977a.625.625 0 1 1-.884-.884L34.116 25l-3.535-3.535a.625.625 0 1 1 .884-.884zM15 25.625a.625.625 0 1 1 0-1.25zM35 25v.625H15v-1.25h20z" fill="#294982"/></svg>`,
      responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
            }
          },
           {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          },
        ]
    });
 
const $slider = $('.slick-marquees');

  // if ($slider.hasClass('slick-initialized')) return;

  $slider.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,
    swipe: false,
    touchMove: false,
    variableWidth: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5
        }
      }
    ]
  });
  $('.featured-collection-slider').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    adaptiveHeight: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  });



  